<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
        <a-config-provider>
          <template v-slot:renderEmpty>
            <a-empty>
              <span slot="description">还没有数据~</span>
            </a-empty>
          </template>
          <div class="config-provider">
            <a-button  type="primary" :style="{ margin: '5px'}" class="ui-search-action" @click="chooseCourse()">选择课程</a-button>
            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="list.datas"
              :loading="isloading"
              size="small"
            >
              <span slot="status" slot-scope="status">
                <a-tag v-if="status==1" color="green">已发布</a-tag>
                <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
                <a-tag v-else-if="status==2" color="red">直播中</a-tag>
                <a-tag v-else-if="status==3" color="green">已结束</a-tag>
                <a-tag v-else color="gray">已删除</a-tag>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn name="编辑" size="small" @click="showCourse(info.id)" type="primary" />
                <a-divider type="vertical" />
                <pxkeji-btn name="移除" size="small" @click="removeCourse(info.id)" type="default" />
              </span>
            </a-table>
<!--            <div class="totalbox" style="float: left;">-->
<!--              <div>-->
<!--                <span>共有：{{list.pagination.total}}条数据</span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </a-config-provider>

      
      <a-modal
        v-model="courseInfoShow"
        :footer="false"
        destroyOnClose
        width="40%"
        title="课程信息"
        :maskClosable="false"
        class="ui-modal"
      >
        <courseInfo @callbackMethod="closeCourseInfo" :id="list.editId"/>
      </a-modal>
      <a-modal
        v-model="chooseCourseShow"
        :footer="false"
        destroyOnClose
        width="60%"
        :maskClosable="false"
        class="ui-modal"
      >
        <courseChoose @callbackMethod="addCourse" :ids="list.ids" />
      </a-modal>
    </div>
    
  </a-spin>
</template>

<script>
import courseChoose from "./courseChoose.vue";
import courseInfo from "../course/rebroadcastInfo.vue";

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "课程编码"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称"
  },

  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元"
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

var that;

export default {
  name: "courseList",
  props: {
    projectId:String
  },
  watch:{
    id: {
      immediate:true, 
      handler(newVal,oldVal) {
         if(newVal){
          this.GetList();
        }
      }
    } 
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        editId:0,
        ids:[]      
      },
      form: this.$form.createForm(this),
      isloading: false,
      loadingTip: "加载中...",
      chooseCourseShow: false, //选择课程
      courseInfoShow: false, //编辑课程
      thisModelTitle:'',
      modelInfo:{},
    };
  },
  components: {
    courseChoose: courseChoose,
    courseInfo: courseInfo,
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      if(this.projectId){
        this.GetList();
      }
      
    });
  },
  methods: {
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    GetList() {
      if(this.projectId>0){
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .getCourseForProject(
            this.projectId
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
                this.list.datas = res.data;
                this.list.ids=[];
                if(res.data){
                  res.data.forEach(function(item,index){
                    that.list.ids.push(item.id);
                  })
                }
                
              
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }
    },
    //编辑
    showCourse(id) {
      this.list.editId=id;
      this.courseInfoShow = true;
    },
    closeCourseInfo(id){
      if(id){
        //新增，需要增加关联关系
        this.isloading = true;
        this.clearRows();
        this.$api.project
          .addCourseToProject(
            this.projectId,id
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      }
      this.courseInfoShow = false;
    },
    chooseCourse(){
      this.chooseCourseShow=true;
    },
    //选择课程
    addCourse(ids) {
      this.chooseCourseShow = false;
      this.isloading = true;
        this.clearRows();
        this.$api.project
          .addCourseToProject(
            this.projectId,ids
          )
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              that.GetList();
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    removeCourse(id){
       this.$confirm({
          title: "提示",
          content: "您确定要移除课程吗",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isloading = true;
            that.clearRows();
            that.$api.project
              .removeCourseFromProject(
                that.projectId,id
              )
              .then(res => {
                that.isloading = false;
                if (res.errorCode == that.$msg.responseCode.success) {
                  that.GetList();
                } else {
                  that.$message.error(res.errorMsg);
                }
              })
              .catch(() => {
                that.isloading = false;
              });
          },
          onCancel() {}
        });
        
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    },
   
    
  }
};
</script>
<style>
</style>